"use strict";
import { __exports as a } from "./index.es283.js";
var g;
function T() {
  return g ? a : (g = 1, (function(u) {
    Object.defineProperty(u, "__esModule", {
      value: !0
    });
    function m(e, r) {
      for (var t in r) Object.defineProperty(e, t, {
        enumerable: !0,
        get: r[t]
      });
    }
    m(u, {
      DecodeError: function() {
        return b;
      },
      MiddlewareNotFoundError: function() {
        return _;
      },
      MissingStaticPage: function() {
        return R;
      },
      NormalizeError: function() {
        return w;
      },
      PageNotFoundError: function() {
        return S;
      },
      SP: function() {
        return d;
      },
      ST: function() {
        return O;
      },
      WEB_VITALS: function() {
        return p;
      },
      execOnce: function() {
        return E;
      },
      getDisplayName: function() {
        return s;
      },
      getLocationOrigin: function() {
        return c;
      },
      getURL: function() {
        return P;
      },
      isAbsoluteUrl: function() {
        return N;
      },
      isResSent: function() {
        return f;
      },
      loadGetInitialProps: function() {
        return l;
      },
      normalizeRepeatedSlashes: function() {
        return y;
      },
      stringifyError: function() {
        return v;
      }
    });
    const p = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function E(e) {
      let r = !1, t;
      return function() {
        for (var i = arguments.length, n = new Array(i), o = 0; o < i; o++)
          n[o] = arguments[o];
        return r || (r = !0, t = e(...n)), t;
      };
    }
    const h = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, N = (e) => h.test(e);
    function c() {
      const { protocol: e, hostname: r, port: t } = window.location;
      return e + "//" + r + (t ? ":" + t : "");
    }
    function P() {
      const { href: e } = window.location, r = c();
      return e.substring(r.length);
    }
    function s(e) {
      return typeof e == "string" ? e : e.displayName || e.name || "Unknown";
    }
    function f(e) {
      return e.finished || e.headersSent;
    }
    function y(e) {
      const r = e.split("?");
      return r[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (r[1] ? "?" + r.slice(1).join("?") : "");
    }
    async function l(e, r) {
      if (process.env.NODE_ENV !== "production") {
        var t;
        if ((t = e.prototype) != null && t.getInitialProps) {
          const o = '"' + s(e) + '.getInitialProps()" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.';
          throw Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
            value: "E394",
            enumerable: !1,
            configurable: !0
          });
        }
      }
      const i = r.res || r.ctx && r.ctx.res;
      if (!e.getInitialProps)
        return r.ctx && r.Component ? {
          pageProps: await l(r.Component, r.ctx)
        } : {};
      const n = await e.getInitialProps(r);
      if (i && f(i))
        return n;
      if (!n) {
        const o = '"' + s(e) + '.getInitialProps()" should resolve to an object. But found "' + n + '" instead.';
        throw Object.defineProperty(new Error(o), "__NEXT_ERROR_CODE", {
          value: "E394",
          enumerable: !1,
          configurable: !0
        });
      }
      return process.env.NODE_ENV !== "production" && Object.keys(n).length === 0 && !r.ctx && console.warn("" + s(e) + " returned an empty object from `getInitialProps`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps"), n;
    }
    const d = typeof performance < "u", O = d && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((e) => typeof performance[e] == "function");
    class b extends Error {
    }
    class w extends Error {
    }
    class S extends Error {
      constructor(r) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = "Cannot find module for page: " + r;
      }
    }
    class R extends Error {
      constructor(r, t) {
        super(), this.message = "Failed to load static file for page: " + r + " " + t;
      }
    }
    class _ extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function v(e) {
      return JSON.stringify({
        message: e.message,
        stack: e.stack
      });
    }
  })(a), a);
}
export {
  T as __require
};
//# sourceMappingURL=index.es253.js.map
